import { useQuery } from 'react-query';

import { quotesDashboardService } from 'reports/services';
import {
  IQuotesDashboardDetails,
  IQuotesDashboardSummary,
  IQuotesDashboardSummaryRequestPayload,
} from 'reports/types';

export const useGetQuotesDashboardSummary = (
  requestPayload: IQuotesDashboardSummaryRequestPayload
) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['quotesDashboardSummary', requestPayload],
    ({ signal }) => quotesDashboardService.getQuotesDashboardSummary(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    isError,
    isFetching,
    isLoading,
    summary: data?.record as IQuotesDashboardSummary,
  };
};

export const useGetQuotesDashboardDetails = (
  requestPayload: IQuotesDashboardSummaryRequestPayload
) => {
  const { data, isLoading, isFetching, isError } = useQuery(
    ['quotesDashboardDetails', requestPayload],
    ({ signal }) => quotesDashboardService.getQuotesDashboardDetails(requestPayload, signal),
    {
      keepPreviousData: true,
    }
  );

  return {
    details: data?.record as IQuotesDashboardDetails,
    isError,
    isFetching,
    isLoading,
  };
};
